import {gql} from '@apollo/client';

export const PrepareTwoFactorAuthorizationMutation = gql`
  mutation PrepareTwoFactorAuthorization {
    prepareTwoFactorAuthorization {
      errors {
        message
        field
      }
      qrCode
      secret
    }
  }
`;

export const EnableTwoFactorAuthorizationMutation = gql`
  mutation EnableTwoFactorAuthorization($otp: String!) {
    enableTwoFactorAuthorization(otp: $otp) {
      errors {
        message
        field
      }
    }
  }
`;

export const DisableTwoFactorAuthorizationMutation = gql`
  mutation DisableTwoFactorAuthorization($otp: String!) {
    disableTwoFactorAuthorization(otp: $otp) {
      errors {
        message
        field
      }
    }
  }
`;

export const ChangePasswordMutation = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    passwordChange(oldPassword: $oldPassword, newPassword: $newPassword) {
      errors {
        message
        field
      }
    }
  }
`;

export const LinkUserDiscordMutation = gql`
  mutation LinkUserDiscord($code: String!, $redirectPath: String!) {
    discordLinkUser(code: $code, redirectPath: $redirectPath) {
      user {
          id
          email
          linkDate
          username
          globalName
          discriminator
          discordId
        }
      errors {
        message
        field
      }
    }
  }
`;

export const DiscordDisconnectUserMutation = gql`
  mutation DiscordDisconnectUser($id: ID!) {
    discordDisconnectUser(id: $id) {
      errors {
        message
        field
      }
    }
  }
`;
